import React from 'react'
import config from 'app/config'

const HeaderAppName = () => {
    return (
        <zui-headerbar-product-name
            product-name={config.APP_NAME}
            product-sub-name=""
            slot="productName"
        ></zui-headerbar-product-name>
    )
}

export default HeaderAppName
